// Main theme exports
export { default as theme, lightTheme, darkTheme } from './theme';
export type { Theme } from './theme';

// Color palette
export { default as palette } from './colors';

// Context and hooks
export {
  ThemeProvider,
  useTheme,
  useThemeColors,
  useThemeSpacing,
  useThemeShadows,
  useThemeTypography,
  useThemeBorderRadius,
} from './ThemeContext';
export { LayoutSizeProvider, useLayoutSize } from './LayoutSizeContext';
export type { LayoutSize } from './LayoutSizeContext';
export {
  LAYOUT_BREAKPOINTS,
  getSizeClass,
  isMediumOrLarger,
  isExpandedOrLarger,
} from './layoutBreakpoints';
export type { LayoutSizeClass } from './layoutBreakpoints';

// Utilities
export {
  createThemedStyles,
  getColor,
  getSpacing,
  getSpacings,
  getBorderRadius,
  getShadow,
  getTypography,
  withOpacity,
  createVariant,
  cardStyle,
  buttonStyle,
  inputStyle,
  deviceStyle,
  easingCurves,
  // Icon style utilities
  getIconContainerStyle,
} from './utils';
export type { IconStyleVariant, IconContainerStyle } from './utils';

// Font helpers - centralized font management
export { GTFonts, PoppinsFonts, LatoFonts } from './fonts';

// Export commonly used patterns for quick access
export const colors = {
  // Quick access to semantic colors from light theme
  primary: '#FF6B35',
  secondary: '#2196F3',
  success: '#4CAF50',
  warning: '#FFD700',
  error: '#FF5722',
  info: '#42A5F5',
  premium: '#9C27B0',

  // Quick access to neutrals
  white: '#FFFFFF',
  black: '#000000',
  background: '#EDF0F4',
  surface: '#FFFFFF',
  text: '#212121',
  textSecondary: '#757575',
  border: '#EEEEEE',
  link: '#0091ea',
};
